package flagpack.icons.medium

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Anguilla Flag (20x15dp)
 *
 * - ISO Alpha-2: AI
 * - ISO Alpha-3: AIA
 * - ISO Numeric: 660
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Medium.Anguilla: ImageVector by lazy {
    ImageVector.Builder(
        name = "Anguilla:AI:AIA:660:Medium",
        defaultWidth = 20.dp,
        defaultHeight = 15.dp,
        viewportWidth = 20f,
        viewportHeight = 15f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF2E42A5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                stroke = SolidColor(Color(0xFFE6E617)),
                strokeLineWidth = 0.5f
            ) {
                moveTo(16.219f, 13.477f)
                curveTo(15.591f, 13.477f, 15.167f, 13.329f, 14.87f, 13.083f)
                curveTo(14.571f, 12.834f, 14.368f, 12.459f, 14.237f, 11.942f)
                curveTo(14.105f, 11.424f, 14.051f, 10.785f, 14.03f, 10.036f)
                curveTo(14.016f, 9.509f, 14.018f, 8.938f, 14.021f, 8.325f)
                curveTo(14.022f, 8.144f, 14.023f, 7.959f, 14.023f, 7.77f)
                horizontalLineTo(18.476f)
                curveTo(18.555f, 9.245f, 18.577f, 10.661f, 18.292f, 11.723f)
                curveTo(18.143f, 12.278f, 17.917f, 12.713f, 17.592f, 13.009f)
                curveTo(17.272f, 13.3f, 16.834f, 13.477f, 16.219f, 13.477f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF82E5FF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(14.246f, 12.696f)
                curveTo(14.619f, 13.53f, 15.273f, 13.946f, 16.206f, 13.946f)
                curveTo(17.133f, 13.946f, 17.789f, 13.535f, 18.173f, 12.713f)
                lineTo(14.246f, 12.696f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE18600)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(14.653f, 9.75f)
                curveTo(14.653f, 10.579f, 15.328f, 11.25f, 16.159f, 11.25f)
                curveTo(16.99f, 11.25f, 17.666f, 10.579f, 17.666f, 9.75f)
                curveTo(17.666f, 8.921f, 16.99f, 8.25f, 16.159f, 8.25f)
                curveTo(15.328f, 8.25f, 14.653f, 8.921f, 14.653f, 9.75f)
                close()
                moveTo(17.041f, 9.75f)
                curveTo(17.041f, 10.233f, 16.646f, 10.625f, 16.159f, 10.625f)
                curveTo(15.673f, 10.625f, 15.278f, 10.233f, 15.278f, 9.75f)
                curveTo(15.278f, 9.267f, 15.673f, 8.875f, 16.159f, 8.875f)
                curveTo(16.646f, 8.875f, 17.041f, 9.267f, 17.041f, 9.75f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE18600)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(15.905f, 8.041f)
                curveTo(15.905f, 8.041f, 15.357f, 8.29f, 15.476f, 8.757f)
                curveTo(15.595f, 9.224f, 15.729f, 9.291f, 15.729f, 9.291f)
                curveTo(15.729f, 9.291f, 15.923f, 8.279f, 16.705f, 8.279f)
                lineTo(15.905f, 8.041f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE18600)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(14.908f, 10.562f)
                curveTo(14.908f, 10.562f, 15.365f, 10.954f, 15.738f, 10.648f)
                curveTo(16.111f, 10.343f, 16.115f, 10.193f, 16.115f, 10.193f)
                curveTo(16.115f, 10.193f, 15.116f, 10.445f, 14.785f, 9.737f)
                lineTo(14.908f, 10.562f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE18600)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(17.65f, 10.509f)
                curveTo(17.65f, 10.509f, 17.667f, 9.908f, 17.195f, 9.81f)
                curveTo(16.723f, 9.712f, 16.604f, 9.803f, 16.604f, 9.803f)
                curveTo(16.604f, 9.803f, 17.428f, 10.421f, 17.086f, 11.123f)
                lineTo(17.65f, 10.509f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(11f)
                verticalLineToRelative(9f)
                horizontalLineToRelative(-11f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFF2E42A5))) {
                moveTo(0f, 0f)
                horizontalLineToRelative(11f)
                verticalLineToRelative(9f)
                horizontalLineToRelative(-11f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(-1.253f, 8.125f)
                lineTo(1.223f, 9.211f)
                lineTo(11.306f, 1.18f)
                lineTo(12.612f, -0.433f)
                lineTo(9.965f, -0.796f)
                lineTo(5.852f, 2.665f)
                lineTo(2.542f, 4.996f)
                lineTo(-1.253f, 8.125f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF50100))) {
                moveTo(-0.914f, 8.886f)
                lineTo(0.347f, 9.516f)
                lineTo(12.143f, -0.583f)
                horizontalLineTo(10.372f)
                lineTo(-0.914f, 8.886f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(12.503f, 8.125f)
                lineTo(10.306f, 9.521f)
                lineTo(-0.056f, 1.18f)
                lineTo(-1.362f, -0.433f)
                lineTo(1.285f, -0.796f)
                lineTo(5.398f, 2.665f)
                lineTo(8.708f, 4.996f)
                lineTo(12.503f, 8.125f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF50100))) {
                moveTo(12.418f, 8.671f)
                lineTo(11.157f, 9.301f)
                lineTo(6.134f, 4.977f)
                lineTo(4.645f, 4.494f)
                lineTo(-1.488f, -0.427f)
                horizontalLineTo(0.283f)
                lineTo(6.413f, 4.377f)
                lineTo(8.041f, 4.957f)
                lineTo(12.418f, 8.671f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF50100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6f, 0f)
                horizontalLineTo(5f)
                verticalLineTo(4f)
                horizontalLineTo(0f)
                verticalLineTo(5f)
                horizontalLineTo(5f)
                verticalLineTo(9f)
                horizontalLineTo(6f)
                verticalLineTo(5f)
                horizontalLineTo(11f)
                verticalLineTo(4f)
                horizontalLineTo(6f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.063f, 0f)
                horizontalLineTo(6.938f)
                verticalLineTo(3.063f)
                lineTo(11f, 3f)
                verticalLineTo(5.875f)
                lineTo(6.938f, 5.938f)
                verticalLineTo(9f)
                horizontalLineTo(4.063f)
                verticalLineTo(5.938f)
                lineTo(0f, 5.875f)
                verticalLineTo(3f)
                lineTo(4.063f, 3.063f)
                verticalLineTo(0f)
                close()
                moveTo(5f, 4f)
                horizontalLineTo(0f)
                verticalLineTo(5f)
                horizontalLineTo(5f)
                verticalLineTo(9f)
                horizontalLineTo(6f)
                verticalLineTo(5f)
                horizontalLineTo(11f)
                verticalLineTo(4f)
                horizontalLineTo(6f)
                verticalLineTo(0f)
                horizontalLineTo(5f)
                verticalLineTo(4f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun AnguillaPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Medium.Anguilla,
            contentDescription = "Anguilla Flag"
        )
    }
}
